const setPageTrackingData = (data: any) => {
  if (typeof window !== 'undefined') {
    window.currentPageTrackingData = { ...data };
  }
};

export default setPageTrackingData;
